module.exports = {"title":"Матильда и великие князья Романовы","description":"Сыновья, любовные связи, браки","image":"https://matilda.lenta.ru/img/sharepic.jpg","url":"https://matilda.lenta.ru/","fbappid":1739439559424315,"trackingID":"UA-105301080-16","clientTrackingID":"UA-78538268-24"}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 4
// module chunks = 0